import { observer } from "mobx-react-lite";

import { TeamChats } from "../team-chats/TeamChats";
import { useChatRowsOptions } from "../team-chats/useChatRowsOptions";
import { useVisibleRowsCounts } from "../useVisibleRowsCounts";

export const ChannelsSection = observer(function ChannelsSection() {
  const chatRows = useChatRowsOptions();

  const { containerToFitRef, chatsContainerRef, visibleChatsCount } = useVisibleRowsCounts({
    chats: chatRows,
  });

  return (
    <div ref={containerToFitRef}>
      <TeamChats rowsContainerRef={chatsContainerRef} visibleCount={visibleChatsCount} />
    </div>
  );
});
